"use client";
import { create } from "zustand";

const STORAGE_KEY = "rentData";

const loadStoredRent = () => {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const useRentStore = create((set) => ({
  rentData: null,
  loading: false,
  setLoading: (loading) => set({ loading }),
  setRentData: (rentData) => set({ rentData }),
  clearRentData: () => set({ rentData: null }),
  hydrateRent: () => {
    const stored = loadStoredRent();
    if (stored) set({ rentData: stored });
  },
}));

export const persistRentData = (data) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const clearPersistedRent = () => {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
};
